<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            )
            svg(width='100%' height='100%' viewBox='0 0 1280 500' preserveAspectRatio='xMidYMid meet')
                g(ref='road')
                    path(d='M1306.5 453.5V1838H-20V436.372C-17.1339 443.538 449.116 695.961 449.116 695.961L406.439 483.666L554.116 602.632L458.749 281.551L756.611 708.616C773.954 641.33 796.982 567.528 796.982 567.528L808.461 653.773L921.454 398.939L931.506 543.305L1172.77 220L1081.75 729.079L1306.5 453.5Z' fill='black')
                g(transform='translate(130 0)')
                    g(ref='car') 
                        g(ref='carRight')
                            path(d='M881.978 445.125L881.774 441.557C881.395 435.243 875.91 430.378 869.579 430.757L821.053 433.633C820.295 433.677 819.551 433.801 818.85 433.983L787.064 384.439C776.831 368.49 753.958 356 735.008 356H639.496V374.265H735.008C747.685 374.265 764.811 383.623 771.652 394.285L809.901 453.908C759.836 447.441 701.924 443.742 640.175 443.742H639.496V498.136C639.496 498.136 639.496 498.136 639.504 498.136C675.09 498.136 707.102 505.36 729.37 516.867V545.313H639.496V587.778H756.051V607.726C756.051 617.222 763.841 624.993 773.345 624.993H842.446C851.95 624.993 859.732 617.222 859.732 607.726V512.708C859.732 497.466 853.707 483.571 843.926 473.251C845.589 472.712 847.136 472.144 848.456 471.569L872.117 461.227C877.923 458.693 882.365 451.439 881.978 445.125ZM834.029 524.951L791.572 545.328H753.039V509.781L834.029 491.734V524.951Z' fill='black')
                        g(ref='carLeft')
                            path(d='M546.873 374.265H640.503V356H546.873C527.953 356 504.977 368.351 494.576 384.133L461.594 434.121C460.748 433.859 459.872 433.692 458.953 433.633L410.421 430.757C404.09 430.378 398.605 435.243 398.233 441.557L398.021 445.125C397.635 451.439 402.084 458.693 407.897 461.227L431.551 471.569C432.878 472.151 434.424 472.712 436.08 473.251C426.306 483.571 420.275 497.466 420.275 512.708V607.733C420.275 617.229 428.057 625 437.561 625H506.669C516.18 625 523.963 617.229 523.963 607.733V587.786H640.503V545.32H550.629V516.874C572.904 505.36 604.917 498.143 640.496 498.143V443.749C578.55 443.778 520.484 447.529 470.332 454.054L509.842 394.176C516.851 383.572 534.152 374.265 546.873 374.265ZM526.961 509.781V545.328H488.428L445.971 524.951V491.734L526.961 509.781Z' fill='black')

</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

//import * as basicScroll from 'basicscroll';

export default {
    props: {
        rows: {
            type: String
        },
        modifierClass: String,
        settings: Object,
        isActive: Boolean
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll();
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .set(this.$refs.car, {scale: 0.5})
                .set(this.$refs.road, {y: 1000})
                .fromTo(this.$refs.car, {scale: 0.5}, {duration: 1, transformOrigin: '50% 50%', scale: 1})
                .fromTo(this.$refs.road, {y: 1000}, {duration: 0.3, y: -100}, 1)
                .fromTo(this.$refs.carLeft, {x: 0, y: 0, rotate: 0}, {duration: 1, transformOrigin: '0% 0%', x: -1000, y: -400, rotate: -100}, 1.2)
                .fromTo(this.$refs.carRight, {x: 0, y: 0, rotate: 0}, {duration: 1, transformOrigin: '100% 0%', x: 1000, y: -400, rotate: 100}, 1.2);
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 150vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;
    height: 100vh;
    background-color: var(--theme);
}

// svg {
//     width: 100%;
//     height: auto;
//     @media (--viewport-tablet) {
//         width: auto;
//         height: 100%;
//     }
// }
</style>
